import {FishDate} from './fish-date';

export type DayViewModel = {
  date: FishDate,
  disabled: boolean
}

export type WeekViewModel = {
  number: number,
  days: DayViewModel[]
}

export type MonthViewModel = {
  firstDate: FishDate,
  number: number,
  year: number,
  weeks: WeekViewModel[],
  weekdays: number[]
};

export enum NavigationEvent {
  PREV,
  NEXT
}
